import styles from "./ArticleTitle.module.scss";
import cx from "classnames";
import { ArticleTitleFragment, ArticleLayout } from "types/api";
import { gql } from "utils/urql";

const ArticleTitle = ({
  title,
  layout,
}: ArticleTitleFragment & { layout: ArticleLayout }) => {
  return (
    <h1
      className={cx(styles.root, layout === "feature" && styles.feature)}
      dangerouslySetInnerHTML={{ __html: title }}
    />
  );
};

ArticleTitle.fragment = gql`
  fragment articleTitle on Article {
    title
  }
`;

export default ArticleTitle;
